<template>
  <div
    class="modal fade"
    id="editReason"
    tabindex="-1"
    role="dialog"
    aria-labelledby="editReasonLabel"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4
            class="modal-title"
            id="editReasonLabel"
          >
            {{ $t('string.editReason') }}
          </h4>
        </div>
        <div class="modal-body">
          <div
            class="form-group"
            :class="{'has-error' : validations['number']}"
          >
            <label
              for="edit_reason_number"
              class="required"
            >{{ $t('string.number') }}</label>
            <input
              type="number"
              id="edit_reason_number"
              class="form-control"
              v-model="reason.number"
            >
            <template v-if="validations['number']">
              <span class="help-block">{{ validations['number'][0] }}</span>
            </template>
          </div>
          <div
            class="form-group"
            :class="{'has-error' : validations['reason']}"
          >
            <label
              for="edit_reason"
              class="required"
            >{{ $t('string.reason') }}</label>
            <input
              type="text"
              id="edit_reason"
              class="form-control"
              v-model="reason.reason"
            >
            <template v-if="validations['reason']">
              <span class="help-block">{{ validations['reason'][0] }}</span>
            </template>
          </div>
          <div class="form-group">
            <label>{{ $t('string.formTypes') }}</label>
            <div class="checkbox">
              <label>
                <input
                  type="checkbox"
                  v-model="reason.for_cancellation"
                > {{ $t('string.forCancellation') }}
              </label>
            </div>
            <div class="checkbox">
              <label>
                <input
                  type="checkbox"
                  v-model="reason.for_rejection"
                > {{ $t('string.forRejection') }}
              </label>
            </div>
          </div>
          <div class="form-group">
            <label>{{ $t('string.productTypes') }}</label>
            <div class="checkbox">
              <label>
                <input
                  type="checkbox"
                  v-model="reason.for_payday"
                > {{ $t('string.forPayday') }}
              </label>
            </div>
            <div class="checkbox">
              <label>
                <input
                  type="checkbox"
                  v-model="reason.for_personal"
                > {{ $t('string.forPersonal') }}
              </label>
            </div>
            <div class="checkbox">
              <label>
                <input
                  type="checkbox"
                  v-model="reason.for_installment"
                > {{ $t('string.forInstallment') }}
              </label>
            </div>
            <div class="checkbox">
              <label>
                <input
                  type="checkbox"
                  v-model="reason.for_pawn"
                > {{ $t('string.forPawn') }}
              </label>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            ref="close"
            class="btn btn-default"
            data-dismiss="modal"
          >
            {{ $t('button.close') }}
          </button>
          <button
            type="button"
            @click="onSave"
            :disabled="isSaveWaiting"
            class="btn btn-success"
          >
            <i
              class="fa fa-spinner fa-spin"
              v-if="isSaveWaiting"
            /> {{ $t('button.update') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'EditReasonModal',
  data () {
    return {
      validations: {},
      reason: {
        number: null,
        reason: null,
        for_cancellation: false,
        for_rejection: false,
        for_payday: false,
        for_personal: false,
        for_installment: false,
        for_pawn: false,
        reason_id: null
      },
      isSaveWaiting: false
    }
  },
  computed: {
    ...mapState({
      toggle_edit_modal: state => state.reason.toggle_edit_modal,
      reason_id: state => state.reason.reason_id
    })
  },
  watch: {
    toggle_edit_modal () {
      if (this.reason_id) {
        this.getReason(this.reason_id)
      }
    }
  },
  methods: {
    onResetForm () {
      this.validations = {}
      this.reason = {
        number: null,
        reason: null,
        for_cancellation: false,
        for_rejection: false,
        for_payday: false,
        for_personal: false,
        for_installment: false,
        for_pawn: false,
        reason_id: null
      }
      this.$refs.close.click()
    },
    onSave () {
      this.isSaveWaiting = true
      this.$axios.post(this.$base_api + '/api/v4/backend/reason/update', this.reason)
        .then(({ data }) => {
          if (data.data) {
            this.$emit('refreshList')
            this.onResponseSuccess()
            this.onResetForm()
          }
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.validations = error.response.data.errors
          } else {
            this.onResponseError(error)
          }
        })
        .finally(() => {
          this.isSaveWaiting = false
        })
    },
    getReason (id) {
      this.$axios.post(this.$base_api + '/api/v4/backend/reason/show', {
        reason_id: id
      }).then(({ data }) => {
        if (data.data) {
          this.reason = data.data
          this.reason.reason_id = data.data.id
        }
      }).catch((error) => {
        this.onResponseError(error)
      }).finally(() => {
        this.isSaveWaiting = false
      })
    }
  }
}
</script>

<style scoped>

</style>
